export default {
  PLAN_PURCHASE: "plan_purchase",
  GIFT: "gift"
};
